module.exports = __webpack_public_path__ + "static/media/cody-happy.2614ec9c.png";